import { Injectable, TemplateRef } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';

@Injectable()
export class CustomMatDialog extends MatDialog {
  override open<T, D = any, R = any>(
    componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
    config?: MatDialogConfig<D>,
  ): MatDialogRef<T, R> {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    return super.open(componentOrTemplateRef, config);
  }
}
